export class RestrictedFunction {
  restrictedFunctionId: number;
  restrictedFunctionName: string;
}

export class UserRestrictedFunction {
  userId: number;
  userGroupId: number;
  restrictedFunctionId: number;
  grant: boolean;
  deny: boolean;
}
